import { createContext } from "react";

export type CanWrite = (profileId?: number | null) => boolean;

// Default fail-open: writable when used outside a ProfileRightsProvider
// (the backend remains the real gate).
export const ProfileRightsContext = createContext<CanWrite>(() => true);
